import { Component } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoadingGridComponent } from 'src/app/cell-renderer/loading-grid/loading-grid.component';
import { TrailerActionsComponent } from '../trailer-actions/trailer-actions.component';
import { TrailerService } from 'src/app/services/trailer.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-trailer-list',
  templateUrl: './trailer-list.component.html',
  styleUrls: ['./trailer-list.component.css']
})
export class TrailerListComponent {
  constructor(private apiTrailer: TrailerService, private utils: UtilsService, private spinner: NgxSpinnerService) { }

  columnDefs = [
    { field: 'trailer', headerName: 'Remolque' },
    { field: 'plate', headerName: 'Placa' },
    { field: 'year', headerName: 'Año' },
    { field: 'trailer_type.key', headerName: 'Clave Tipo' },
    { field: 'trailer_type.name', headerName: 'Tipo' },
    {
      headerName: 'Accion',
      width: 200,
      cellRenderer: TrailerActionsComponent,
      sortable: false,
      filter: false,
      cellRendererParams: {
        parent: this,
        url_edit: '/trailer/update/',
        module: 'Remolques',
        singular_module: 'Remolque'
      }
    },
  ];

  public loadingCellRenderer: any = LoadingGridComponent;
  public loadingCellRendererParams: any = {
    loadingMessage: 'Espere un momento...',
  };

  public defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
  };

  private gridApi!: GridApi;
  public rowData: any = [];

  ngOnInit(): void { }

  onGridReady(params: any) {
    this.spinner.show();
    this.apiTrailer.listTrailer().subscribe((resp) => {
      this.rowData = resp;
      this.spinner.hide();
    });
  }

  refreshGrid() {
    this.onGridReady({});
  }

  actionDelete(id: number) {
    this.utils.alertSwalConfir({ title: 'Eliminación', text: 'Esta seguro que desea eliminar el remolque seleccionado', icon: 'warning', btn_confirm: 'Elimniar' })
      .then((result) => {
        if (result.isConfirmed) {
          this.spinner.show();
          this.apiTrailer.deleteTrailer(id).subscribe(() => {
            this.spinner.hide();
            this.utils.alertSwal({ title: 'Operación Exitosa', text: 'Se ha realizado la eliminacion del remolque de forma exitosa', icon: 'success' });
            this.onGridReady({});
          }, () => {
            this.spinner.hide();
            this.utils.alertSwal({ title: 'Error', text: 'Se ha presentado un error al intentar eliminar el remolque', icon: 'error' });
          });
        }
      });
  }
}
